export interface TournamentFollow {
  id: string;
  userId: string;
  tournamentId: string;
  createdAt: Date;
}

export interface TournamentFollowWithDetails extends TournamentFollow {
  tournamentName?: string;
  tournamentDescription?: string;
  tournamentStatus?: string;
  tournamentType?: string;
  tournamentIsPublic?: boolean;
  tournamentMaxParticipants?: number;
  tournamentStartDate?: Date;
  tournamentLocation?: string;
  followerCount?: number;
}
